<div class="heading-top">
  <div class="row">
    <div class="dropdown show">
      <a class="btn focus-none bg-none h6 font-weight-bold sm-18 " href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Change your email address<span class="fas fa-angle-down pl-5 ml-5"></span>
      </a>
        <div class="div">
          <span class="sm-12 pl-3">kritin@kritin.com</span>
          <span><button class="btn btn-green sm-12 h-auto text-light ml-3 grey-text">Verfied</button></span>
        </div>
      <input type="email" class="form-control sm-16 border-0 mt-3" id="exampleFormControlInput1" placeholder="Enter a Email Address">
      <button type="submit" class="btn primary-btn mt-3 sm-12 ml-3">Update your Email Address</button>
    </div>
  </div>
  <div class="row">
    
  </div>
  <div class="row">
    
  </div>
</div>
